export default __webpack_public_path__ + "static/media/Manly.e8bc6ff2.jpg";